import React from 'react';
import School from 'material-ui/svg-icons/social/school';

export const lessonTypeIcons = {
  intro: <School className="lesson-card-type-icon intro" />,
  activity: <School className="lesson-card-type-icon activity" />,
  journal: <School className="lesson-card-type-icon journal" />,
  other: <School className="lesson-card-type-icon other" />,
};



// WEBPACK FOOTER //
// ./app/features/shared/constants/lessonTypeIcons.js